import { Trash2 } from "lucide-react"
import DeleteDiscussionModal from "./DeleteDiscussionModal"
import { useState } from "react"
import ReplyModal from "./AddRepliesToDiscussion"
import { TimeUtils } from "../../../utils/TimeUtils"

const DiscussionCard = ({ discussion, fetchDiscussions }) => {

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openReplyModal, setOpenReplyModal] = useState(false)

  return (
    <>
      <div className="w-full bg-background rounded-lg p-4 text-white mb-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center justify-center gap-3">
            <img
              src={discussion?.user?.photoUrl || "https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg"}
              alt={discussion?.user?.name}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <h3 className="font-medium text-textHeading mb-1">{discussion?.user?.name}</h3>
              <p className="text-sm text-textSubHeading mb-0">{TimeUtils.getFormattedTimeDifference(discussion?.updatedAt)}</p>
            </div>
          </div>
          <button onClick={() => setOpenDeleteModal(true)} className="text-textSubHeading hover:text-textHeading transition-colors">
            <Trash2 className="w-5 h-5" />
          </button>
        </div>
        <div className="mt-3">
          <h2 className="text-lg text-textHeading mb-0">{discussion?.title}</h2>
          <p className="text-textSubHeading mb-0">{discussion?.description}</p>
        </div>
        <button onClick={() => setOpenReplyModal(true)} className="mt-2">
          <p className="text-sm text-textSubHeading">
            {discussion?.reactions?.length < 1 ? (
              "No reaction yet"
            ) : (`${discussion?.reactions?.filter(reaction => reaction.status === "active").length} reactions`
            )}
          </p>
        </button>
      </div>

      {openDeleteModal && (
        <DeleteDiscussionModal
          closeHandler={() => setOpenDeleteModal(false)}
          discussion={discussion}
          fetchDiscussions={fetchDiscussions}
        />
      )}
      {openReplyModal && (
        <ReplyModal
          closeHandler={() => setOpenReplyModal(false)}
          discussion={discussion}
        />
      )}
    </>
  )
}

export default DiscussionCard
